import React, { ReactElement } from "react";
import {
  makeStyles,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormHelperText,
} from "@material-ui/core";
import HoverToolTip from "./utilities/HoverToolTip";
import { useEnumStrings } from "../enumStrings";
import { FormikErrors } from "formik";
import { ChamberMemberInput } from "../../graphql/types";

const useStyles = makeStyles(() => ({
  notificationRadioGroup: {
    display: "flex",
    justifyContent: "flex-start",
    paddingTop: "5px",
    width: "100%",
    gap: "40px",
  },
  radio: {
    color: "#E1A731!important",
  },
}));

const ChamberMemberIsSuspendedRadioGroup = ({
  formikSetFieldValue,
  formikValues,
  formikErrors,
  hideHeader = false,
  hideTooltips = false,
  unavailableStatus,
}: {
  formikSetFieldValue: (a: string, b: boolean | any[]) => void;
  formikValues: ChamberMemberInput;
  formikErrors: FormikErrors<ChamberMemberInput>;
  hideHeader?: boolean;
  hideTooltips?: boolean;
  unavailableStatus?: string;
}): ReactElement => {
  const classes = useStyles();
  const enumStrings = useEnumStrings();

  if (unavailableStatus) {
    return <p>Member Status: <strong>{unavailableStatus}</strong>. Use its membership workflow in Chamber Member Pro to change this status.</p>;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
      }}
    >
      {!hideHeader && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h1 style={{ marginBottom: "8px" }}>
            {enumStrings.chamberMember.memberStatus}
          </h1>
          <p
            style={{
              color: "#666666",
              fontSize: "14px",
              lineHeight: "1.5",
              margin: "0 0 16px 0",
              textAlign: "left",
            }}
          >
            {enumStrings.createChamberMemberText.tooltip.membershipStatus.title}
          </p>
        </div>
      )}
      <RadioGroup
        row
        aria-label="isSuspended"
        name="isSuspended"
        id="isSuspended"
        onChange={(e) => {
          formikSetFieldValue(
            "isSuspended",
            e.target.value === "0" ? true : false
          );
        }}
        className={classes.notificationRadioGroup}
        value={formikValues.isSuspended ? 0 : 1}
      >
        {formikValues.isSuspended === undefined ? (
          <FormHelperText
            component="legend"
            style={{
              color: "#f44336",
              paddingTop: "0px",
              textAlign: "left",
            }}
          >
            {formikErrors.isSuspended}
          </FormHelperText>
        ) : null}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            value={1}
            labelPlacement="end"
            control={<Radio className={classes.radio} />}
            label={
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ fontWeight: hideTooltips ? 700 : undefined }}>{enumStrings.CreateChamberMember.Active}</span>
                {!hideTooltips && (
                  <>
                    <div style={{ width: "10px" }} />
                    <HoverToolTip
                      disablePadding
                      description={
                        enumStrings.createChamberMemberText.tooltip.membershipStatus
                          .active
                      }
                      showIt
                    />
                  </>
                )}
              </div>
            }
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            value={0}
            style={{ marginRight: "0px" }}
            control={<Radio className={classes.radio} />}
            label={
              <div style={{ display: "flex", alignItems: "center", margin: 0 }}>
                <span style={{ fontWeight: hideTooltips ? 700 : undefined }}>{enumStrings.CreateChamberMember.Suspended}</span>
                {!hideTooltips && (
                  <>
                    <div style={{ width: "10px" }} />
                    <HoverToolTip
                      disablePadding
                      description={
                        enumStrings.createChamberMemberText.tooltip.membershipStatus
                          .suspended
                      }
                      showIt
                    />
                  </>
                )}
              </div>
            }
            labelPlacement="end"
          />
        </div>
      </RadioGroup>
    </div>
  );
};

export default ChamberMemberIsSuspendedRadioGroup;
